// extracted by mini-css-extract-plugin
export var container = "_c6-1";
export var cornerButtonContainer = "_c6-6";
export var disabled = "_c6-2";
export var dragActive = "_c6-3";
export var fileContainer = "_c6-5";
export var hiddenInput = "_c6-4";
export var widthContainer = "_c6-0";